import { render, staticRenderFns } from "./lastProducts.vue?vue&type=template&id=6d9f341c&"
import script from "./lastProducts.vue?vue&type=script&lang=js&"
export * from "./lastProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports